module.exports = __webpack_public_path__ + "static/media/IKCM06.63d3c987.jpg";